import { atom } from 'jotai';

export const employerSpontaneousCandidatesSearchQueryAtom = atom('');
employerSpontaneousCandidatesSearchQueryAtom.debugLabel = 'employerSpontaneousCandidatesSearchQueryAtom';

export const employerSpontaneousCandidatesShowHiddenFilterAtom = atom(false);
employerSpontaneousCandidatesShowHiddenFilterAtom.debugLabel = 'employerSpontaneousCandidatesHiddenFilterAtom';

export type SpontaneousCandidateRestaurantFilterType = {
  id: string;
  restaurant_name: string;
};

export const employerSpontaneousCandidatesRestaurantFilterAtom = atom<SpontaneousCandidateRestaurantFilterType>({
  id: '',
  restaurant_name: '',
});
employerSpontaneousCandidatesRestaurantFilterAtom.debugLabel = 'employerSpontaneousCandidatesRestaurantFilterAtom';
